(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("@strivr/ui", ["react"], factory);
	else if(typeof exports === 'object')
		exports["@strivr/ui"] = factory(require("react"));
	else
		root["@strivr/ui"] = factory(root["react"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__8156__) => {
return 